import { ChangeEvent } from 'react';
import { CheckMark, Label, Radio } from './RadioButton.styles';
import { IRAdioButtonProps } from './Types';

export function RadioButton({
  checked,
  radioColor,
  id,
  value,
  label,
  name,
  className,
  onChange,
}: IRAdioButtonProps): JSX.Element {
  return (
    <Label
      htmlFor={id}
      className={className}
      $checked={checked}
      radioColor={radioColor}
    >
      <Radio
        type="radio"
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <CheckMark radioColor={radioColor} $checked={checked} />
      {label}
    </Label>
  );
}

RadioButton.defaultProps = {
  className: '',
};
